import React from 'react';

const Error404 = () => {
    return (
        <div>
            <h1 className='text-5xl text-center min-h-screen mt-10'> Error 404 </h1>
        </div>
    );
};

export default Error404;